import type { ReactNode } from 'react';
import { ChatMessageFeedbackContext } from './chat-message-feedback';
import { useMessageFeedback } from './hooks/useMessageFeedback';

export function ChatMessageFeedbackProvider({
  children,
  conversationId,
}: {
  children: ReactNode;
  conversationId: string | undefined;
}) {
  const feedback = useMessageFeedback(conversationId);
  return (
    <ChatMessageFeedbackContext.Provider value={conversationId ? feedback : null}>
      {children}
    </ChatMessageFeedbackContext.Provider>
  );
}
